import { buildSessionAnalyticsParams, postAnalyticsEvent, getParsePointersForSelectedTicket } from './common';
import * as SessionAnalyticsService from 'services/SessionAnalyticsService/SessionAnalyticsService';

const EVENT_TYPES = {
  BUTTON_CLICK: 'BUTTON_CLICK',
  TAKE_CLICK: 'TAKE_CLICK',
  SEND_CLICK: 'SEND_CLICK',
  ESCALATE_CLICK: 'ESCALATE_CLICK',
  JIT_ESCALATION_CLICK: 'JIT_ESCALATION_CLICK',
  QUICK_ACTION_BUTTON_CLICK: 'QUICK_ACTION_BUTTON_CLICK',
  PARTNER_INFO_CLICK: 'PARTNER_INFO_CLICK',
  DUMMY_BUTTON_CLICK: 'DUMMY_BUTTON_CLICK',
};

export const BUTTONS = {
  SEARCH_ORDER: 'SEARCH_ORDER',
  SEARCH_ALL: 'SEARCH_ALL',
  COMPANY_INFO: 'COMPANY_INFO',
  RESPONSE_GUIDE: 'RESPONSE_GUIDE',
  COPY_MACRO_TEXT: 'COPY_MACRO_TEXT',
  ACTIONS: 'ACTIONS',
  MACRO_WIZARD: 'MACRO_WIZARD',
  LAST_PAGE_URL: 'LAST_PAGE_URL',
  TAKE: 'TAKE',
  ESCALATE: 'ESCALATE',
  SEND: 'SEND',
  JIT_ESCALATION_CLICK: 'JIT_ESCALATION_CLICK',
  QUICK_ACTION: 'QUICK_ACTION',
  PARTNER_INFO: 'PARTNER_INFO',
  COPY_SUB_TEXT: 'COPY_SUB_TEXT',
};

export const trackButtonClick = async (buttonName, params = {}) => {
  // get the conversationId that is currently selected
  const parsePointers = getParsePointersForSelectedTicket();
  // add the buttonName as a parameter
  params = Object.assign({ buttonName }, params);

  return await postAnalyticsEvent(EVENT_TYPES.BUTTON_CLICK, parsePointers, params);
};

export const trackTakeButtonClick = async (params = {}) => {
  const parsePointers = getParsePointersForSelectedTicket();
  params = Object.assign({ TAKE: BUTTONS.TAKE }, params);

  return await postAnalyticsEvent(EVENT_TYPES.TAKE_CLICK, parsePointers, params);
};

export const trackSendButtonClick = async (params = {}) => {
  const parsePointers = getParsePointersForSelectedTicket();
  params = Object.assign({ SEND: BUTTONS.SEND }, params);
  const eventParams = buildSessionAnalyticsParams(parsePointers, params);
  SessionAnalyticsService.event(EVENT_TYPES.SEND_CLICK, eventParams);

  return await postAnalyticsEvent(EVENT_TYPES.SEND_CLICK, parsePointers, params);
};

export const trackPartnerInfoButtonClick = async (params = {}) => {
  const parsePointers = getParsePointersForSelectedTicket();
  params = Object.assign({ PARTNER_INFO: BUTTONS.PARTNER_INFO }, params);

  return await postAnalyticsEvent(EVENT_TYPES.PARTNER_INFO_CLICK, parsePointers, params);
};

export const trackEscalateButtonClick = async (params = {}) => {
  const parsePointers = getParsePointersForSelectedTicket();
  params = Object.assign({ ESCALATE: BUTTONS.ESCALATE }, params);

  return await postAnalyticsEvent(EVENT_TYPES.ESCALATE_CLICK, parsePointers, params);
};

export const trackJITEscalationButtonClick = async () => {
  const parsePointers = getParsePointersForSelectedTicket();
  const params = { ESCALATE: BUTTONS.JIT_ESCALATION_CLICK };

  return await postAnalyticsEvent(EVENT_TYPES.JIT_ESCALATION_CLICK, parsePointers, params);
};

export const trackQuickActionClick = async () => {
  const parsePointers = getParsePointersForSelectedTicket();
  const params = { ACTION: BUTTONS.QUICK_ACTION };

  return await postAnalyticsEvent(EVENT_TYPES.QUICK_ACTION_BUTTON_CLICK, parsePointers, params);
};

export const trackDummyButtonClickNode = async (node) => {
  const parsePointers = getParsePointersForSelectedTicket();
  const params = { ACTION: node?.action };

  return await postAnalyticsEvent(EVENT_TYPES.DUMMY_BUTTON_CLICK, parsePointers, params);
};

export const trackDummyButtonClickMacro = async (macro) => {
  const parsePointers = getParsePointersForSelectedTicket();
  const params = { MACRO_TITLE: macro?.fullSubheading };

  return await postAnalyticsEvent(EVENT_TYPES.DUMMY_BUTTON_CLICK, parsePointers, params);
};
